import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Jello from "react-reveal/Jello";
import axios from "axios";

function AggiungiImpiegato() {
  let history = useHistory();

  const initialValues = {
    nome: "",
    provincia: "",
    dataNascita: "",
    CAP: "",
    telefono: "",
    cognome: "",
    comune: "",
    indirizzo: "",
    regione: "",
    email: "",
    password: "",
    nomeIntestatario: "",
    scadenzaCarta: "",
    codiceCarta: "",
    cvc: "",
    codicePatente: "",
    dataRilascio: "",
    nominativo: "",
    scadenzaPatente: "",
    tipo: "",
  };

  const onSubmit = (data) => {
    axios
      .post(
        "https://website-8bit-motors.herokuapp.com/amministratore/aggiungiImpiegato",
        data
      )
      .then((response) => {
        if (response.data.error) {
          alert(response.data.error);
        } else {
          history.push(
            "/amministratore/aggiungiImpiegato/registrazioneCheckImpiegato"
          );
        }
      });
  };

  const validationSchema = Yup.object().shape({
    nome: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(15, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    cognome: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(15, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    provincia: Yup.string()
      .min(2, "Valore non valido: Troppo corto!")
      .max(2, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    CAP: Yup.string().required("Per continuare devi compilare questo campo!"),
    dataNascita: Yup.date().required(
      "Per continuare devi compilare questo campo!"
    ),
    telefono: Yup.string().required(
      "Per continuare devi compilare questo campo!"
    ),
    regione: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(15, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    comune: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(15, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    indirizzo: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(25, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    email: Yup.string()
      .email("Inserisci una email valida")
      .required("Per continuare devi compilare questo campo!"),
    password: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(20, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    nomeIntestatario: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(20, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    codiceCarta: Yup.number("Devi inserire solamente numeri!")
      .min(16, "Valore non valido: Troppo corto!")
      .required("Per continuare devi compilare questo campo!"),
    cvc: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(3, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    scadenzaCarta: Yup.date().required(
      "Per continuare devi compilare questo campo!"
    ),
    scadenzaPatente: Yup.date().required(
      "Per continuare devi compilare questo campo!"
    ),
    nominativo: Yup.string()
      .min(5, "Valore non valido: Troppo corto!")
      .max(20, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    dataRilascio: Yup.date().required(
      "Per continuare devi compilare questo campo!"
    ),
    codicePatente: Yup.string()
      .min(6, "Valore non valido: Troppo corto!")
      .max(6, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    tipo: Yup.string().required("Per continuare devi compilare questo campo!"),
  });

  return (
    <Container fluid className="app">
      <Jello>
        {/* SEZIONE BANNER */}
        <Container
          fluid
          className="head-banner text-white text-center"
          id="banner_accesso"
        >
          <Row>
            <Col>
              <h1>
                <strong>8-Bit Motors</strong>
              </h1>
            </Col>
          </Row>
        </Container>
      </Jello>

      {/* FORM REGISTRAZIONE */}
      <Container className="form_registrazione">
        <h2 align="center" className="mb-3">
          <strong>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-person-lines-fill"
              viewBox="0 0 16 16"
            >
              <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z" />
            </svg>{" "}
            Aggiungi Impiegato
          </strong>
        </h2>
        <h2 className="mt-3">Dati Anagrafici</h2>
        <Formik
          onSubmit={onSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          <Form>
            <Row className="justify-content-md-center mt-3">
              <Col>
                <label className="mb-1 form_registrazione" for="nome">
                  Nome
                </label>
                <ErrorMessage name="nome" component="h6" />
                <Field
                  className="form-control input_registrazione"
                  name="nome"
                  placeholder="Inserisci Nome"
                />
                <label className="mb-1 mt-3 form_registrazione" for="provincia">
                  Provincia
                </label>
                <ErrorMessage name="provincia" component="h6" />
                <Field
                  type="text"
                  className="form-control input_registrazione"
                  name="provincia"
                  placeholder="Inserisci Provincia"
                />
                <label
                  className="mb-1 mt-3 form_registrazione"
                  for="dataDiNascita"
                >
                  Data di Nascita
                </label>
                <ErrorMessage name="dataNascita" component="h6" />
                <Field
                  type="date"
                  className="form-control input_registrazione"
                  name="dataNascita"
                  placeholder="Inserisci Data di Nascita"
                />
                <label className="mb-1 mt-3 form_registrazione" for="cap">
                  CAP
                </label>
                <ErrorMessage name="CAP" component="h6" />
                <Field
                  type="number"
                  className="form-control input_registrazione"
                  name="CAP"
                  placeholder="Inserisci CAP"
                />
                <label className="mb-1 mt-3 form_registrazione" for="telefono">
                  Telefono
                </label>
                <ErrorMessage name="telefono" component="h6" />
                <Field
                  type="number"
                  className="form-control input_registrazione"
                  name="telefono"
                  placeholder="Inserisci Telefono"
                />
              </Col>
              <Col>
                <label className="mb-1 form_registrazione">Cognome</label>
                <ErrorMessage name="cognome" component="h6" />
                <Field
                  type="text"
                  className="form-control input_registrazione"
                  name="cognome"
                  placeholder="Inserisci Cognome"
                />
                <label className="mb-1 mt-3 form_registrazione">Regione</label>
                <ErrorMessage name="regione" component="h6" />
                <Field
                  type="text"
                  className="form-control input_registrazione"
                  name="regione"
                  placeholder="Inserisci Regione"
                />
                <label
                  className="mb-1 mt-3 form_registrazione"
                  name="comune"
                  for="comune"
                >
                  Comune
                </label>
                <ErrorMessage name="comune" component="h6" />
                <Field
                  type="text"
                  className="form-control input_registrazione"
                  name="comune"
                  placeholder="Inserisci Comune"
                />
                <label
                  className="mb-1 mt-3 form_registrazione"
                  name="indirizzo"
                  for="indirizzo"
                >
                  Indirizzo
                </label>
                <ErrorMessage name="indirizzo" component="h6" />
                <Field
                  type="text"
                  className="form-control input_registrazione"
                  name="indirizzo"
                  placeholder="Inserisci Indirizzo"
                />
                <label className="mb-1 mt-4 form_registrazione" for="tipo">
                  Tipo Impiegato
                </label>
                <ErrorMessage name="tipo" component="h6" />
                <Field
                  type="text"
                  as="select"
                  className="form-control input_registrazione"
                  name="tipo"
                  placeholder="Inserisci Tipo"
                >
                  <option value="" name="tipo">
                    ...
                  </option>
                  <option value="Autista" name="tipo">
                    Autista
                  </option>
                  <option value="Addetto alla Consegna" name="tipo">
                    Addetto alla Consegna
                  </option>
                </Field>
              </Col>
            </Row>

            {/* SEZIONE PAGAMENTO */}

            <h2 className="mt-3">Dati Pagamento</h2>
            <Row>
              <Col>
                <label
                  class="mb-1 mt-3 form_registrazione"
                  for="nomeIntestatario"
                >
                  Nome Intestatario
                </label>
                <ErrorMessage name="nomeIntestatario" component="h6" />
                <Field
                  type="text"
                  class="form-control input_registrazione"
                  placeholder="Inserisci Nome Intestatario"
                  name="nomeIntestatario"
                />
                <label class="mb-1 mt-3 form_registrazione" for="scadenzaCarta">
                  Scadenza Carta
                </label>
                <ErrorMessage name="scadenzaCarta" component="h6" />
                <Field
                  type="date"
                  class="form-control input_registrazione"
                  placeholder="Inserisci Scadenza Carta"
                  name="scadenzaCarta"
                />
              </Col>
              <Col>
                <label class="mb-1 mt-3 form_registrazione" for="codiceCarta">
                  Codice Carta
                </label>
                <ErrorMessage name="codiceCarta" component="h6" />
                <Field
                  type="string"
                  class="form-control input_registrazione"
                  placeholder="Inserisci Codice Carta"
                  name="codiceCarta"
                />
                <label class="mb-1 mt-3 form_registrazione" for="cvc">
                  CVC
                </label>
                <ErrorMessage name="cvc" component="h6" />
                <Field
                  type="number"
                  class="form-control input_registrazione"
                  placeholder="Inserisci CVC"
                  name="cvc"
                ></Field>
              </Col>
            </Row>

            {/* SEZIONE PATENTE */}

            <h2 className="mt-3">Dati Patente</h2>
            <Row>
              <Col>
                <label class="mb-1 mt-3 form_registrazione" for="codicePatente">
                  Codice Patente
                </label>
                <ErrorMessage name="codicePatente" component="h6" />
                <Field
                  type="text"
                  class="form-control input_registrazione"
                  placeholder="Inserisci Codice Patente"
                  name="codicePatente"
                />
                <label
                  class="mb-1 mt-3 form_registrazione"
                  for="scadenzaPatente"
                >
                  Scadenza Patente
                </label>
                <ErrorMessage name="scadenzaPatente" component="h6" />
                <Field
                  type="date"
                  class="form-control input_registrazione"
                  placeholder="Inserisci Scadenza"
                  name="scadenzaPatente"
                ></Field>
              </Col>
              <Col>
                <label class="mb-1 mt-3 form_registrazione" for="dataRilascio">
                  Data Rilascio
                </label>
                <ErrorMessage name="dataRilascio" component="h6" />
                <Field
                  type="date"
                  class="form-control input_registrazione"
                  placeholder="Inserisci Data Rilascio"
                  name="dataRilascio"
                />
                <label class="mb-1 mt-3 form_registrazione" for="nominativo">
                  Nominativo
                </label>
                <ErrorMessage name="nominativo" component="h6" />
                <Field
                  type="text"
                  class="form-control input_registrazione"
                  placeholder="Inserisci Nominativo"
                  name="nominativo"
                />
              </Col>
            </Row>

            {/* SEZIONE ACCOUNT */}
            <Row className="justify-content-md-center mt-3">
              <h2>Dati Account</h2>
              <Col>
                <label className="mb-1 mt-3 form_registrazione">E-mail</label>
                <ErrorMessage name="email" component="h6" />
                <Field
                  id="email"
                  type="email"
                  className="form-control input_registrazione"
                  name="email"
                  placeholder="Inserisci E-mail"
                />
                <label className="mb-1 mt-3 form_registrazione" for="password">
                  Password
                </label>
                <ErrorMessage name="password" component="h6" />
                <Field
                  id="password"
                  type="password"
                  className="form-control input_registrazione"
                  name="password"
                  placeholder="Inserisci Password"
                />
              </Col>
              <Col>
                <label
                  className="mb-1 mt-3 form_registrazione"
                  for="confermaEmail"
                >
                  Conferma E-mail
                </label>
                <Field
                  type="email"
                  className="form-control input_registrazione"
                  name="confermaEmail"
                  placeholder="Inserisci E-mail"
                />
                <label
                  className="mb-1 mt-3 form_registrazione"
                  for="confermaPassword"
                >
                  Conferma Password
                </label>
                <Field
                  id="pass"
                  type="text"
                  className="form-control input_registrazione"
                  name="confermaPassword"
                  placeholder="Inserisci Password"
                />
              </Col>
            </Row>

            {/* CONFERMA */}
            <Button variant="success" className="mt-3" type="submit">
              Conferma
            </Button>
          </Form>
        </Formik>
      </Container>
    </Container>
  );
}

export default AggiungiImpiegato;
